export default __webpack_public_path__ + "static/media/wheel.f236b821.jpg";